module.exports = __webpack_public_path__ + "static/img/stamp_agree.8d2ec205.svg";